module.exports = __webpack_public_path__ + "assets/icon.3ab19eb2.svg";